module.exports = __webpack_public_path__ + "img/Menu-03.56fb0f29.png";